/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import moment from "moment";

interface ContasPagarItem {
  emissao: string;
  vencimento: string;
  nome: string;
  cpf: string;
  historico: string;
  numero: string;
  vpagar: number;
}

interface GrupoContas {
  contas: {
    nome: string;
    cpf: string;
    vpagar: number;
  };
  contaspagar: ContasPagarItem[];
}

async function RelatorioPagar(dados: GrupoContas[], periodo: string) {

  const linhas: any[] = [];
  let totalGeral = 0;

  dados.forEach((grupo) => {

    grupo.contaspagar.forEach((r) => {

      totalGeral += r.vpagar ?? 0;

      linhas.push([
        {
          text: moment(r.emissao).format("DD/MM/YYYY"),
          fontSize: 8
        },
        {
          text: moment(r.vencimento).format("DD/MM/YYYY"),
          fontSize: 8
        },
        {
          text: r.numero ?? "",
          fontSize: 8
        },
        {
          text: r.nome + " - " + r.cpf,
          fontSize: 8
        },
        {
          text: r.historico ?? "",
          fontSize: 8
        },
        {
          text: formatMoney(r.vpagar),
          alignment: "right",
          bold: true,
          fontSize: 8
        }
      ]);

    });

  });

  const documentDefinition: any = {

    pageSize: "A4",
    pageOrientation: "landscape",

    pageMargins: [25, 25, 25, 25],

    content: [

      {
        text: process.env.REACT_APP_URL_EMPRESA,
        fontSize: 14,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 4]
      },

      {
        text: "RELATÓRIO DE CONTAS A PAGAR",
        fontSize: 12,
        bold: true,
        alignment: "center"
      },

      {
        text: periodo,
        alignment: "center",
        fontSize: 9,
        margin: [0, 0, 0, 10]
      },

      {
        table: {

          headerRows: 1,

          widths: [
            70,  // emissão
            70,  // vencimento
            80,  // número
            220, // fornecedor
            "*", // histórico
            90   // valor
          ],

          body: [

            [
              { text: "Emissão", bold: true, fillColor: "#e5e7eb", fontSize: 9 },
              { text: "Vencimento", bold: true, fillColor: "#e5e7eb", fontSize: 9 },
              { text: "Número", bold: true, fillColor: "#e5e7eb", fontSize: 9 },
              { text: "Parceiro", bold: true, fillColor: "#e5e7eb", fontSize: 9 },
              { text: "Histórico", bold: true, fillColor: "#e5e7eb", fontSize: 9 },
              { text: "Valor", bold: true, alignment: "right", fillColor: "#e5e7eb", fontSize: 9 }
            ],

            ...linhas

          ]

        },

        layout: {

          fillColor: function (rowIndex: number) {

            if (rowIndex === 0) return null;

            return rowIndex % 2 === 0 ? "#f9fafb" : null;

          },

          hLineColor: () => "#d1d5db",
          vLineWidth: () => 0

        }

      },

      {
        text: "TOTAL A PAGAR: " + formatMoney(totalGeral),
        alignment: "right",
        bold: true,
        fontSize: 11,
        margin: [0, 15, 0, 0]
      }

    ]

  };

  pdfMake.createPdf(documentDefinition).open();

}

function formatMoney(value: number) {

  const v = Number(value ?? 0);

  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(v.toFixed(2)));

}

export default RelatorioPagar;